import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, ViewChild } from "@angular/core";
import { BaseControlComponent } from "../base/base-control.component";
import { Moment } from "jalali-moment";
import { IDatePickerConfig, ECalendarValue } from "projects/persian-date-picker/src/lib";
import { SelectorService } from "../base/selector.service";
@Component({
  //moduleId: module.id,
  selector: "time-picker",
  templateUrl: "time-picker.template.html",
  styleUrls: ["time-picker.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimePickerComponent extends BaseControlComponent<string> {
  @Input() showSeconds = true;
  displayDate: Moment | string;
  validationMinDate: Moment;
  validationMaxDate: Moment;

  jalaliConfigExtension: IDatePickerConfig = {
    firstDayOfWeek: "sa",
    monthFormat: "MMMM YYYY",
    weekDayFormat: "dd",
    dayBtnFormat: "D",
    monthBtnFormat: "MMMM",
    locale: "fa",
  };
  gregorianSystemDefaults: IDatePickerConfig = {
    firstDayOfWeek: "su",
    monthFormat: "MMM, YYYY",
    disableKeypress: false,
    allowMultiSelect: false,
    closeOnSelect: undefined,
    closeOnSelectDelay: 100,
    openOnFocus: true,
    openOnClick: true,
    onOpenDelay: 0,
    weekDayFormat: "ddd",
    appendTo: document.body,
    showNearMonthDays: true,
    showWeekNumbers: false,
    enableMonthSelector: true,
    yearFormat: "YYYY",
    showGoToCurrent: true,
    dayBtnFormat: "DD",
    monthBtnFormat: "MMM",
    hours12Format: "hh",
    hours24Format: "HH",
    meridiemFormat: "A",
    minutesFormat: "mm",
    minutesInterval: 1,
    secondsFormat: "ss",
    secondsInterval: 1,
    showTwentyFourHours: false,
    timeSeparator: ":",
    multipleYearsNavigateBy: 10,
    showMultipleYearsNavigation: false,
    locale: "en",
    hideInputContainer: false,
    returnedValueType: ECalendarValue.String,
    unSelectOnClick: true,
    hideOnOutsideClick: true,
  };

  config: IDatePickerConfig = {};

  constructor(protected selectorService: SelectorService, protected cd: ChangeDetectorRef) {
    super(selectorService, cd);
  }

  ngAfterViewInit(): void {
    this.config = { ...this.gregorianSystemDefaults, ...this.jalaliConfigExtension, showSeconds: this.showSeconds };
    this.cd.detectChanges();
  }

  change(newValue: any) {
    if (newValue) {
      this.valueChange.emit(newValue);
    }
  }
}
